<template>
    <div>
        <template v-if="$store.state.userInfo.email">
            <div class="main-wrapper">
                <DrivingSchoolHeader />
<!--                <Navigation />-->
                <div class="main-wrapper__content">
                    <div class="main-wrapper__content--sidebar">
                        <div class="container-fluid">
                            <DrivingSchoolSidebar/>
                        </div>
                    </div>
                    <div class="main-wrapper__content--current-page">
                        <div class="container-fluid">
                            <router-view/>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
            <SessionExpiredModal
                :count="$root.count"
            />
        </template>


        <template v-else="isBusy">
            <Preloader />
        </template>
    </div>
</template>

<script>
    import Preloader from '@/components/Preloader';
    import Navigation from '@/components/Navigation';
    import DrivingSchoolSidebar from '@/components/DrivingSchool/DrivingSchoolSidebar';
    import Footer from '@/components/Footer';
    import SessionExpiredModal from '@/components/SessionExpiredModal';
    import DrivingSchoolHeader from './DrivingSchoolHeader';


    export default {
        name: 'DrivingSchoolSide',
        components: {
            Navigation,
            Preloader,
            DrivingSchoolSidebar,
            Footer,
            SessionExpiredModal,
            DrivingSchoolHeader,
        },
        computed: {
            isUserLogged() {
                return this.$store.getters.getAuthUserInfo.id;
            }
        },
        methods: {
            updateUserInfo() {
                let url = 'auth/user';
                this.apiGet(url).then(response => {
                    if (response.data.data) {
                        this.$store.dispatch('signIn', {
                            access_token: this.$ls.getItem('access_token'),
                            data: response.data.data
                        });
                        this.$store.dispatch('updateCalcGaranties', response.data.data.calcQuotes);
                    }
                });
            },
        },
        mounted() {
            this.updateUserInfo();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/DrivingSchool/DrivingSchoolSide.vue